var map = {
	"./prod.config.json": 151,
	"./qa.config.json": 152,
	"./stg.config.json": 153
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/.*\.config\.json$
// module id = 150
// module chunks = 0